import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MedmalStepService {

    public StepNo: number;

    private subject = new Subject<any>();

    setStepNum(StepNo: number) {
        this.subject.next(StepNo);
    }


    getStepNum(): Observable<string> {
        if (sessionStorage.getItem("MedmalStep") != null) {
            this.StepNo = Number(sessionStorage.getItem("MedmalStep"));
            this.subject.next(this.StepNo);
        }
        return this.subject.asObservable();
    }




}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/MedmalStepService.ts